


























import { Component, Prop, Vue } from "vue-property-decorator";

interface ComboItem {
  key: string | null;
  value: string;
}

@Component({})
export default class ComboRoles extends Vue {
  //Props
  @Prop({ default: true }) readonly todosTipos!: boolean;
  @Prop({ default: null }) readonly value!: number | number[] | null;
  @Prop({ default: false }) readonly multiple!: boolean;
  @Prop({ default: null }) readonly rules!: Array<(v: any) => string | true>;

  //Atributos
  itemsTipos: ComboItem[] = [
    {
      key: null,
      value: "Nenhum",
    },
    {
      key: "Admin",
      value: "Admin",
    },
    {
      key: "Gerente",
      value: "Gerente",
    },
    {
      key: "Atendimento",
      value: "Atendimento",
    },
    {
      key: "Vendas",
      value: "Vendas",
    },
    {
      key: "Suporte",
      value: "Suporte",
    },
    {
      key: "Marketing",
      value: "Marketing",
    },
  ];

  //Computados
  get tipo() {
    return this.value;
  }

  mounted() {
    if (!this.todosTipos) this.itemsTipos.splice(0, 1);
  }

  onChangeTipo(val: number | number[] | null) {
    this.$emit("input", val);
  }
}
